module.exports = __webpack_public_path__ + "static/media/good_effect_arrows.da362d94.svg";